import User from '@/common/user'
export const orderRoutes = [{
    path: '/order',
    name: 'order',
    component: () => {
        return import('@/views/page/order/index.vue')
    },
    children: [{
            path: 'smsauth/:orderId',
            component() {
                return import('@/views/page/order/smsauth.vue')
            }
        }, {
            path: 'templogin/:type',
            name: 'order.templogin',
            meta: {
                title: '家长您好'
            },
            component() {
                return import('@/views/page/order/templogin/templogin.vue')
            }
        }, {
            path: 'addwechat',
            name: 'order.addwechat',
            async beforeEnter(to, from, next) {
                const isLogined = await User.isLogin()
                if (!isLogined) {
                    const from = encodeURIComponent(to.path)
                    next(`/order/templogin/wechat?from=${from}`)
                } else {
                    next()
                }
            },
            component() {
                return import('@/views/page/order/addwechat/addwechat.vue')
            },
            meta: {
                title: '添加老师微信'
            }
        }, {
            path: 'create/:productId',
            name: 'order.create',
            component: () => {
                return import('@/views/page/order/create/index.vue')
            },
            meta: {
                title: '确认订单'
            }
        }, {
            path: 'create2/:productId',
            name: 'order.create2',
            component: () => {
                return import('@/views/page/order/create/index2.vue')
            },
            meta: {
                title: '确认订单'
            }
        }, {
            path: 'query/:orderId',
            name: 'order.query',
            component: () => {
                return import('@/views/page/order/query/index.vue')
            },
            meta: {
                requireAuth: true,
                title: '订单状态'
            }
        }, {
            path: 'repay/:orderId',
            name: 'order.repay',
            component: () => {
                return import('@/views/page/order/repay/index.vue')
            },
            meta: {
                title: '等待支付',
                requireAuth: true
            }
        }, {
            path: 'my/logistics/:orderId',
            component: () => {
                return import('@/views/page/order/my/logistics_list.vue')
            },
            meta: {
                requireAuth: true
            }
        }, {
            path: 'success/:orderId',
            name: 'order.success',
            component: () => {
                return import('@/views/page/order/success.vue')
            },
            meta: {
                requireAuth: true
            }
        }, {
            /**
             * 社群渠道 没有特殊需求不需要改动
             */
            path: 'success2/:orderId',
            name: 'order.success2',
            component() {
                return import('@/views/page/order/success2.vue')
            },
            meta: {
                title: '订单详情',
                requireAuth: true
            }
        }, {
            path: 'my',
            component: () => {
                return import('@/views/page/order/my.vue')
            },
            meta: {
                requireAuth: true
            }
        },
        {
            path: 'apply_bill',
            component: () => {
                return import('@/views/page/order/applyBill.vue')
            },
            meta: {
                requireAuth: true,
                title: '申请发票'
            }
        },
        {
            path: 'logistics_detail',
            component: () => {
                return import('@/views/page/order/logistics_detail.vue')
            },
            meta: {
                requireAuth: true,
                title: '物流信息'
            }
        },
        {
            path: 'bill_detail',
            component: () => {
                return import('@/views/page/order/billDetail.vue')
            },
            meta: {
                requireAuth: true,
                title: '申请发票'
            }
        }, {
            path: 'apply_bill_success',
            component: () => {
                return import('@/views/page/order/applyBillSuccess.vue')
            },
            meta: {
                requireAuth: true,
                title: '申请发票'
            }
        }
    ]
}]
